"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REVIEW_FORM_OPENED = exports.REVIEW_FORM_CLOSED = exports.REVIEW_EDITED = exports.REVIEW_DELETED = exports.REVIEW_CREATED = exports.RATING_CLICKED = void 0;
var required = ['organizationId', 'groupId', 'assetId', 'version', 'name', 'type', 'rating'];
var REVIEW_CREATED = exports.REVIEW_CREATED = 'Review created';
var REVIEW_DELETED = exports.REVIEW_DELETED = 'Review deleted';
var REVIEW_EDITED = exports.REVIEW_EDITED = 'Review edited';
var REVIEW_FORM_OPENED = exports.REVIEW_FORM_OPENED = 'Review form opened';
var REVIEW_FORM_CLOSED = exports.REVIEW_FORM_CLOSED = 'Review form closed';
var RATING_CLICKED = exports.RATING_CLICKED = {
  name: 'Rating clicked',
  required: required
};
//# sourceMappingURL=events.js.map